import Layout from '@src/Layout'
import { locationReplace } from '@/utils/helper'
// 往组件里注入params和query， 类似react-router
function createPropsFn(defaultQuery = {}) {
  return function(route) {
    return {
      query: Object.assign({}, defaultQuery, route.query)
    }
  }
}
const bmCommon = 'https://m.zhuanzhuan.com/u/bm_common/'

export default {
  path: '/help',
  component: Layout,
  props: { className: 'help-wrapper' },
  children: [
    {
      path: 'bm-agreement', // 替换魔方页
      name: 'bm-agreement',
      meta: { title: '转转回收用户服务协议' },
      beforeEnter: () => {
        locationReplace(
          'https://m.zhuanzhuan.com/Mzhuanzhuan/zhuanzhuan/zzactivity/magic/5e74d50b273de95e2b047256/index.html'
        )
      }
    },
    {
      path: 'appreciation-service', // 替换魔方页面
      name: 'appreciation-service',
      alias: '/aftersale/desc',
      meta: { title: '增值服务说明' },
      beforeEnter: () => {
        locationReplace(
          'https://m.zhuanzhuan.com/Mzhuanzhuan/zhuanzhuan/zzactivity/magic/5e75dd0d8ac3395e211e6159/index.html'
        )
      }
    },
    {
      path: 'center',
      name: 'help-center',
      meta: {
        title: '回收帮助中心',
        pageId: 'S2763', // 将作为页面埋点的 actionType
        level: 2
      },
      beforeEnter: () => {
        locationReplace(`${bmCommon}help/center`)
      }
    },
    {
      path: 'change-price-factors', // 24/3/9 流量为0 ，考虑删除
      name: 'change-price-factors',
      props: createPropsFn({ brandId: 10532 }),
      meta: { title: '影响价格3大因素' },
      component: () =>
        import(/* webpackChunkName: "help-change-price-factors" */ '@app/help/change-price-factors')
    },
    {
      path: 'release2bm', // 页面没有流量了，考虑删除
      name: 'release2bm',
      props: createPropsFn(),
      meta: { title: '转转回收' },
      component: () =>
        import(/* webpackChunkName: "release2bm" */ '@app/help/release2bm')
    },
    {
      path: 'rank-list',
      name: 'rank-list',
      props: createPropsFn(),
      meta: {
        title: '转转排行榜',
        pageId: 'C5391', // 将作为页面埋点的 actionType
        level: 2
      },
      component: () =>
        import(
          /* webpackChunkName: "rank-list" */ '@app/help/rank-list/index.vue'
        )
    },
    {
      path: 'tools',
      name: 'tools',
      props: createPropsFn(),
      meta: { title: '测试demo' },
      component: () =>
        import(
          /* webpackChunkName: "tools" */ '@app/help/tools.vue'
        )
    },
    {
      path: 'mine',
      name: 'mine',
      meta: {
        title: '个人中心',
        pageId: 'G8447',
        level: 2
      },
      component: () =>
        import(
          /* webpackChunkName: "mine" */ '@app/help/mine'
        )
    }
  ]
}
